import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const CriteriaSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */
    const [form, setForm] = useState({
        heading: "",
        description: "",
        note_1: "",
        note_2: "",
    });

    /* ---------------- TABLE ROWS STATE ---------------- */
    const [rows, setRows] = useState([
        { class_name: "", age_group: "" },
    ]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchCriteriaSection();
    }, []);

    const fetchCriteriaSection = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/admission_page/get_criteria_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { criteria_section, criteria_table } = res.data.data;

                setForm({
                    heading: criteria_section.heading || "",
                    description: criteria_section.description || "",
                    note_1: criteria_section.note_1 || "",
                    note_2: criteria_section.note_2 || "",
                });

                setRows(
                    criteria_table.length
                        ? criteria_table
                        : [{ class_name: "", age_group: "" }]
                );
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- INPUT HANDLERS ---------------- */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleRowChange = (index, e) => {
        const updated = [...rows];
        updated[index][e.target.name] = e.target.value;
        setRows(updated);
    };

    /* ---------------- ADD / DELETE ROW ---------------- */
    const addRow = () => {
        setRows([...rows, { class_name: "", age_group: "" }]);
    };

    const deleteRow = (index) => {
        if (rows.length <= 1) return;

        const updated = rows.filter((_, i) => i !== index);
        setRows(updated);
    };

    /* ---------------- SUBMIT ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("rows", JSON.stringify(rows));

            const res = await axios.post(
                `${baseAPIUrl}admin/admission_page/add_edit_criteria_section`,
                formData,
                { withCredentials: true }
            );

            setMessage(res.data.msg);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Criteria Section</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active">Admission page</li>
                                <li className="breadcrumb-item active">Criteria section</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h4>Edit Criteria Section</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                {message && (
                                    <p className="text-center text-danger">{message}</p>
                                )}

                                {/* Heading */}
                                <div className="form-group">
                                    <label>Heading</label>
                                    <input
                                        type="text"
                                        name="heading"
                                        className="form-control"
                                        placeholder="Heading"
                                        value={form.heading}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Description */}
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        name="description"
                                        rows="4"
                                        className="form-control"
                                        placeholder="Description"
                                        value={form.description}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Table */}
                                <div className="form-group">
                                    <label>Criteria Table</label>

                                    {rows.map((row, index) => (
                                        <div
                                            key={index}
                                            style={{ display: "flex", gap: "10px", marginTop: "8px" }}
                                        >
                                            <input
                                                type="text"
                                                name="class_name"
                                                className="form-control"
                                                placeholder="Class"
                                                value={row.class_name}
                                                onChange={(e) => handleRowChange(index, e)}
                                            />

                                            <input
                                                type="text"
                                                name="age_group"
                                                className="form-control"
                                                placeholder="Age Group"
                                                value={row.age_group}
                                                onChange={(e) => handleRowChange(index, e)}
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => deleteRow(index)}
                                                disabled={rows.length === 1}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    ))}

                                    <button
                                        type="button"
                                        className="btn btn-success mt-3"
                                        onClick={addRow}
                                    >
                                        + Add Row
                                    </button>
                                </div>

                                {/* Notes */}
                                <div className="form-group">
                                    <label>Note 1</label>
                                    <textarea
                                        name="note_1"
                                        rows="3"
                                        className="form-control"
                                        placeholder="Note 1"
                                        value={form.note_1}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Note 2</label>
                                    <textarea
                                        name="note_2"
                                        rows="3"
                                        className="form-control"
                                        placeholder="Note 2"
                                        value={form.note_2}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CriteriaSection;
